import { Helmet } from "react-helmet";
import {
    Autocomplete,
    Box,
    Button,
    Container,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Toolbar,
    Typography,
    Avatar,
    InputAdornment,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    RadioGroup,
    Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { findIndex } from 'lodash';
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import Icon from '@mui/material/Icon';
import fileBrowser from "../../icons/file-browser.svg";
import Search from "@mui/icons-material/Search";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../services/global.service";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
import { ReactComponent as Route } from "../../assets/images/route.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";
import { ReactComponent as BackIcon } from "../../icons/arrow-left.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import StaticTimePicker from '@mui/lab/StaticTimePicker';
import SimpleDialog from "../../components/SimpleDialog";
import ConfirmDialog from "../../components/ConfirmDialog";
import manageForm from "../../services/manageForm.service";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";

const useStyles = makeStyles({
    select: {
        '& div ': {
            padding: "7.9px 7.9px 7.9px 15px"
        },
    },
    boxLeft: {
        width: "25%",
        "padding-bottom": "25px",
    },
    boxRight: {
        width: "75%",
        "padding-bottom": "25px",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "border-radius": "10px !important"
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: "25px"
    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
});


const DialogRoute = (props) => {
    const { open, close, dataFilter, currentData, valueCycleType, valueFormType, valueCycleName, valueWorkflowStatus, dataWorkflowStatus, isProbation } = props
    const classes = useStyles();
    const { t } = useTranslation();
    const [isNext, setIsNext] = React.useState(false);
    const [isRoute, setIsRoute] = React.useState(false);
    const [search, setSearchValue] = React.useState("");
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [lengthResult, setLengthResult] = React.useState(0);
    const [workflowStatusValue, setWorkflowStatusValue] = React.useState([]);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [employee, setEmployee] = React.useState([]);
    const [val, setVal] = React.useState([]);
    const [workflowStatus, setWorkflowStatus] = React.useState("");
    const [selected, setSelected] = React.useState([]);
    useEffect(() => {
        dataSerachs()
    }, [search]);
    useEffect(() => {
        if (open) {
            // if (Util.formatData(dataFilter?.form_type, []).length > 0) {
            //     let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === valueFormType)
            //     if (Util.formatData(filterData, []).length > 0) {
            //         setWorkflowStatusValue(filterData[0]?.routes)
            //     }
            // }
            if (Util.formatData(dataWorkflowStatus, []).length > 0) {

                let list_status = [...dataWorkflowStatus]

                if (isProbation) {
                    let idx = findIndex(list_status, { code: 'draft' })
                    if (idx !== -1) list_status.splice(idx, 1)
                }

                setWorkflowStatusValue(list_status)
            }
            console.log(dataWorkflowStatus, 333);
            setSelected([])
            setIsNext(false)
            setIsRoute(false)
            setEmployee(Util.formatData(currentData, []))
            dataSerachs(Util.formatData(currentData, []))
        }
    }, [open]);
    const dataSerachs = (datas) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(datas !== undefined && datas !== null ? datas : employee))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            console.log('search', search, dataSerach);
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs?.employee).some(key => {
                    if (key === 'code' || key === 'name' || key === 'position' || key === 'organization' || key === 'form_name' || key === 'form_type') {
                        return rs?.employee[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    /*
                    if (key === 'form_status') {
                        return rs?.employee[key].label.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    */
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        setLengthResult(result.length);
        setMainItems(result)
    };
    const handleCloseDialog = () => {
        close(false);
        setIsNext(false)
        setIsRoute(false)
    };
    const handleSubmit = () => {
        // setIsNext(false)
        // setIsRoute(false)
        setDiscardDialog(true)
    };
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    const validationSchema = yup.object({
        cycle: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        formType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        workflowStatus: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });

    const formik = useFormik({
        initialValues: {
            cycle: "",
            formType: "",
            workflowStatus: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            let data = {
                form_type: values?.formType,
                cycle_id: values?.cycle,
                form_status: values?.workflowStatus
            }
            manageForm.getRouteListEmployees(data).then((rs) => {
                setEmployee(Util.formatData(rs?.data?.employees, []))
                dataSerachs(Util.formatData(rs?.data?.employees, []))
                setIsNext(true)
            }).catch((err) => {
            })
        },
    });
    const formikChange = (val, field) => {
        formik.setFieldValue(field, val.target.value)
        if (field === "workflowStatus") {
            setWorkflowStatus(val.target.value)
        }
    }

    const submit = (data) => {
        formik.submitForm()
    }
    const handleRoute = () => {
        setIsRoute(true)
        setIsNext(false)
    }
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = mainItems.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, serial) => {
        const selectedIndex = selected.indexOf(serial);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, serial);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const isSelected = (serial) => selected.indexOf(serial) !== -1;

    const [startDate, setStartDate] = React.useState(null);
    const [value, setValue] = React.useState(new Date());
    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }

    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        let data = {
            form_type: Util.formatData(valueFormType, "evaluate"),
            cycle_id: Util.formatData(valueCycleName, ""),
            form_status: Util.formatData(workflowStatus, ""),
            forms: Util.formatData(selected, [])
        }
        manageForm.changeRoute(data).then((rs) => {
            handleDiscardDialog(false)
            openSuccessDeleteDialog(true)
        }).catch((err) => {

        })
        // openDialog(false);
        // setFormData({
        //     code: '',
        //     nameEN: '',
        //     nameTH: '',
        //     icon: iconIcon,
        //     backgroundColor: backgroundColorValue
        // });
    };
    const handleDirect = () => {
        openSuccessDeleteDialog(false)
        close("load");
    }
    const selectRoute = (field, data) => {
        formik.setFieldValue(field, data)
    };
    const navigate = useNavigate();
    const handleBack = () => {
        if (isNext === true) {
            setIsNext(false)
            setIsRoute(false)
        } else if (isRoute === true) {
            setIsRoute(false)
            setIsNext(true)
        }

    };

    let checkData = () => {
        let check = false
        if (Util.formatData(formik?.values?.formType, false) === false) {
            check = true
        } else if (Util.formatData(formik?.values?.cycle, false) === false) {
            check = true
        } else if (Util.formatData(formik?.values?.workflowStatus, false) === false) {
            check = true
        }
        return check
    }

    useEffect(() => {
        // if (Util.formatData(dataFilter?.form_type, []).length > 0) {
        //     let filterData = dataFilter?.form_type.filter((rs) => rs?.type?.code === valueFormType)
        //     if (Util.formatData(filterData, []).length > 0) {
        //         setWorkflowStatusValue(filterData[0]?.routes)
        //     }
        // }
        if (Util.formatData(dataWorkflowStatus, []).length > 0) {
            setWorkflowStatusValue(dataWorkflowStatus)
        }

        formik.setFieldValue("cycle", "")
        formik.setFieldValue("workflowStatus", "")
    }, []);
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            mainItems.sort(function (b, a) {
                if (key === "employee") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }

                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            mainItems.sort(function (a, b) {
                if (key === "employee") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    let getName = (code) => {
        if (Util.formatData(workflowStatusValue, []).length > 0) {
            let data = workflowStatusValue.filter((rs) => rs?.code === code)
            if (data.length > 0 && Util.formatData(data[0]?.label, false) !== false) {
                return data[0]?.label
            } else {
                return "-"
            }
        }
        return "-"
    }
    return (
        <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth={isRoute ? "xs" : "lg"} PaperProps={{ sx: { padding: '30px 30px' } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    {isRoute ?
                        <Box pr="20px" sx={{ display: "flex", alignItems: "center" }}>
                            <BackIcon style={{ cursor: "pointer" }} onClick={handleBack} />
                        </Box>
                        : null
                    }
                    {isRoute ?
                        <Typography fontWeight="600" fontSize={24} lineHeight="26.4px" color="#404349">
                            Change Route
                        </Typography>
                        :
                        <Typography fontWeight="600" fontSize={24} lineHeight="26.4px" color="#404349">
                            Route
                        </Typography>
                    }
                </Box>
                <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0" }}>
                {isRoute ?
                    <Box>
                        <Typography fontWeight="500" color="#404349" fontSize={18} lineHeight="26.91px" pt="20px" >
                            Change Route:
                        </Typography>
                        <Box sx={{ ".MuiFormControl-root": { marginTop: "0px" }, ".MuiFormControlLabel-root": { marginLeft: "0px", marginTop: "15px", ".MuiTypography-root": { paddingLeft: "17px", fontWeight: "400", fontSize: "16px", lineHeight: "24px", color: "#404349", }, ".MuiRadio-root": { padding: "0" } } }}>
                            <FormControl component="fieldset" sx={{ marginBottom: 0, marginTop: "10px" }}>
                                <RadioGroup aria-label="gender" name="controlled-radio-buttons-group" aria-labelledby="demo-controlled-radio-buttons-group"
                                    value={workflowStatus}
                                    onChange={(newValue) => {
                                        setWorkflowStatus(newValue.target.value);
                                    }}
                                >
                                    {
                                        workflowStatusValue?.length > 0 ?
                                            workflowStatusValue.map(vl => {
                                                return (
                                                    <FormControlLabel value={vl?.code} control={<Radio />} label={vl?.label} sx={{ margintop: 0, marginBottom: 0 }} />
                                                )
                                            })
                                            : <MenuItem value="">
                                                ไม่พบข้อมูล
                                            </MenuItem>
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Box>
                        <Box sx={{ textAlign: "center" }} pt="20px">
                            <Button
                                size="small"
                                aria-controls="simple-menu"
                                aria-haspopup="true"
                                onClick={handleSubmit}
                                color="primary"
                                variant="contained"
                                sx={{ height: "45px", p: "0 20px", textTransform: "none" }}
                                disabled={formik?.values?.workflowStatus === workflowStatus}
                            >
                                <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                    {/* {t('label.next')} */}
                                    Change
                                </Typography>
                            </Button>
                        </Box>
                    </Box>
                    :
                    <Box sx={{ overflow: "hidden", height: "calc(100vh - 180px)" }}>
                        <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" color="#A3A3A3" pt="20px" >
                            Please select the item for changing route.
                        </Typography>
                        <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" pt="20px" color="#404349">
                            Showing {mainItems.length} results
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} pt="10px">
                            <Box sx={{ width: "100%", maxWidth: "400px" }}>
                                <TextField
                                    id="input-with-icon-textfield"
                                    fullWidth
                                    // placeholder={t('label.search')}
                                    placeholder="Search"
                                    size="small"
                                    sx={{ background: "#fff", width: "100%", "input": { padding: "11px 14px" }, ".MuiOutlinedInput-root": { color: "#404349", } }}
                                    className="searchTextField-h40"
                                    value={search}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search style={{ color: "#C4C4C4" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                {selected.length > 0 ?
                                    <Box sx={{ backgroundColor: "#5DA1961A", padding: "9.05px 20px", borderRadius: "5px" }}>
                                        <Typography color="#5DA196" fontSize={18} lineHeight="26.91px" fontWeight={400} >Selected Items: {selected.length}</Typography>
                                    </Box>
                                    : null
                                }
                                <Button
                                    size="small"
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    onClick={handleRoute}
                                    color="primary"
                                    variant="contained"
                                    sx={{ height: "45px", p: "0 20px", textTransform: "none", "margin-left": "30px" }}
                                    disabled={selected.length > 0 ? false : true}
                                >
                                    <Route className={classes.plusSvg} />
                                    <Typography pl="10px" sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                        Change Route
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box sx={{ background: "#FAFAFA" }}>
                                    <Box
                                        py="15px"
                                        sx={{ display: "flex", "flex-direction": "row" }}
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "40.96%" }} pr="20px">
                                            <Checkbox
                                                sx={{ margin: "0 20px", padding: "0" }}
                                                checked={employee.length > 0 && selected.length === employee.length}
                                                indeterminate={selected.length > 0 ? selected.length !== employee.length : false}
                                                onChange={handleSelectAllClick}
                                            />
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('label.titleForm.template')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "32.12%" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('admin.label.employeeName')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "12.30%" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('label.formType')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "14.62%" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('label.titleForm.formStatus')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {/* <Divider width="100%" /> */}
                                </Box>
                                <Box sx={{ overflowY: "overlay", height: " calc(100vh - 400px)" }}>
                                    {mainItems !== undefined && mainItems !== null && mainItems.length > 0 ? mainItems.map((row, index) => {
                                        const isItemSelected = isSelected(row.id)
                                        return (
                                            <Box>
                                                <Box sx={{ width: "100%", position: "relative" }}>
                                                    <Box
                                                        sx={{ height: "70px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                    >
                                                        {/* 40.96+32.12+10.30+13.38 */}
                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "40.96%" }} pr="20px">
                                                            <Box sx={{ display: "flex", alignItems: "center" }}
                                                                onClick={(event) => handleClick(event, row.id)}
                                                                role="checkbox"
                                                                aria-checked={isItemSelected}
                                                                tabIndex={-1}
                                                                key={row.serial}
                                                                selected={isItemSelected}>
                                                                <Checkbox
                                                                    sx={{ margin: "0 20px", padding: "0" }}
                                                                    // onChange={e => changeType(data?.serial)} 
                                                                    checked={isItemSelected}
                                                                />
                                                            </Box>
                                                            <Box sx={{ width: "calc(100% - 65px)" }} >
                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                    {Util.formatData(row?.template?.name, "-")}
                                                                </Typography>
                                                                <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                    {t('label.period')}: {Util.formatData(row?.template?.start_at, false) === false && Util.formatData(row?.template?.end_at, false) === false ? "-" :
                                                                        Util.formatData(row?.template?.start_at, false) === false ? Util.dateDayFormatAdmin(row?.template?.end_at) :
                                                                            Util.formatData(row?.template?.end_at, false) === false ? Util.dateDayFormatAdmin(row?.template?.start_at) :
                                                                                `${Util.dateDayFormatAdmin(row?.template?.start_at)} - ${Util.dateDayFormatAdmin(row?.template?.end_at)}`}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "32.12%" }} pr="20px">
                                                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", "flex-direction": "row", }}>
                                                                <Avatar
                                                                    src={Util.formatData(row?.employee?.photo, "")}
                                                                    sx={{
                                                                        cursor: "pointer",
                                                                        width: 40,
                                                                        height: 40,
                                                                    }}
                                                                />
                                                                <Box sx={{ width: "calc(100% - 40px)" }} pl="20px">
                                                                    <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                        {Util.formatData(row?.employee?.name, "-")} ({Util.formatData(row?.employee?.code, "-")})
                                                                    </Typography>
                                                                    <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                        {Util.formatData(row?.employee?.position, "-")} {Util.formatData(row?.employee?.organization, false) === false ? "" : `(${row?.employee?.organization})`}

                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "12.30%" }} pr="20px">
                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                {Util.formatData(row?.type, "-")}
                                                            </Typography>
                                                        </Box>
                                                        {/* <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "14.62%" }} pr="20px">
                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                {Util.formatData(row?.form_status?.label, "-")}
                                                            </Typography>
                                                        </Box> */}
                                                        <Box py="8px" px="20px" sx={{ display: "flex", alignItems: "center", "flex-direction": "row", "max-width": "100%", width: "14.62%", border: row?.form_status?.code === "draft" && row?.type !== "goal" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: row?.form_status?.code === "draft" && row?.type !== "goal" ? "none" : row?.form_status?.color + "1A" }} >
                                                            <Typography fontSize={16} lineHeight="23.96px" fontWeight={400} color={row?.form_status?.color} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {Util.formatData(row?.form_status?.label, "-")}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                        )
                                    })
                                        :
                                        <Box sx={{ "padding-top": "50px", "text-align": "center" }}>
                                            <Nodata />
                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                {t('label.noDataFilter')}
                                            </Typography>
                                            <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                {t('label.tryChangingFilter')}
                                            </Typography>
                                        </Box>
                                    }
                                </Box>
                            </Paper>
                        </div>
                    </Box>
                }
            </DialogContent>
            <SimpleDialog
                open={isSuccessDeleteDialogOpen}
                setValue={openSuccessDeleteDialog}
                text="Route was changed"
                doDirect={() => handleDirect()}
                page={true}
            />
            <ConfirmDialog
                open={discardDialog}
                warning={true}
                doConfirm={() => handleDiscardChangeConfirm()}
                setValue={() => handleDiscardDialog(false)}
                title="Confirmation of Change Route"
                text={`Are you sure to change route from “${valueWorkflowStatus}” to “${getName(workflowStatus)}” ?`} />
        </Dialog>
    );
};
export default DialogRoute;
